import React from 'react';
import { StarIcon, AwardIcon, UsersIcon, ShieldCheckIcon, LeafIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center justify-center" style={{
    backgroundImage: 'url(https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920)',
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-135">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50" data-id="element-136" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-137">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight" style={{
        textShadow: '0 2px 20px rgba(0,0,0,0.6)'
      }} data-id="element-138">
          Spotless Spaces. Lasting Impressions.
        </h1>
        <p className="text-lg md:text-xl text-white/90 font-light max-w-2xl mx-auto mb-10" style={{
        textShadow: '0 1px 10px rgba(0,0,0,0.4)'
      }} data-id="element-139">
          Professional commercial cleaning that keeps your business looking its
          best — every single day.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-140">
          <button onClick={() => scrollToSection('contact')} className="w-full sm:w-auto bg-[#6BBF3B] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#5aa832] transition-colors text-lg" data-id="element-141">
            Get a Free Quote
          </button>
          <button onClick={() => scrollToSection('services')} className="w-full sm:w-auto border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white/10 transition-colors text-lg" data-id="element-142">
            Our Services
          </button>
        </div>

        {/* Trust Strip */}
        <div className="mt-8 bg-black/30 backdrop-blur-md rounded-2xl px-6 py-5 mx-auto max-w-3xl" data-id="element-143">
          <p className="text-white/80 text-sm mb-4" data-id="element-144">
            Trusted by 100+ Local Businesses
          </p>
          <div className="flex items-center justify-center gap-3 sm:gap-5 flex-wrap" data-id="element-145">
            <div className="flex items-center gap-1.5 bg-white/15 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-146">
              <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-147" />
              <span className="text-white text-sm font-medium" data-id="element-148">
                5-Star Rated
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/15 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-149">
              <AwardIcon className="w-4 h-4 text-[#6BBF3B]" data-id="element-150" />
              <span className="text-white text-sm font-medium" data-id="element-151">
                20+ Years Experience
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/15 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-152">
              <UsersIcon className="w-4 h-4 text-[#0E7C86]" data-id="element-153" />
              <span className="text-white text-sm font-medium" data-id="element-154">
                500+ Clients Served
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/15 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-155">
              <ShieldCheckIcon className="w-4 h-4 text-white/80" data-id="element-156" />
              <span className="text-white text-sm font-medium" data-id="element-157">
                100% Satisfaction
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/15 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-158">
              <LeafIcon className="w-4 h-4 text-[#6BBF3B]" data-id="element-159" />
              <span className="text-white text-sm font-medium" data-id="element-160">
                Eco-Certified
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}